import { DomainLayer } from "@iventis/map-engine/src/state/map.state.types";
import { ExportFormat } from "@iventis/domain-model/model/exportFormat";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { MapObjectsExport } from "@iventis/domain-model/model/mapObjectsExport";
import { mappingApi } from "@iventis/api/src/api";
import { v4 as uuid } from "uuid";
import { translate } from "@iventis/translations/translation";
import { Content } from "@iventis/translations";
import { IventisFilterOperator } from "@iventis/data-table";
import { FilterFormat } from "@iventis/types";
import { MapLayer } from "@iventis/domain-model/model/mapLayer";
import { MapObjectExportCadOptions } from "@iventis/domain-model/model/mapObjectExportCadOptions";

export const exportLayerAsGeoJson = (layers: DomainLayer[], mapId: string, unitOfMeasurement: UnitOfMeasurement) => {
    const request: MapObjectsExport = {
        mapId,
        layerIds: layers.map(({ id }) => id),
        export: undefined,
        exportFormat: ExportFormat.GeoJson,
        unitOfMeasurement,
        filters: [],
        sorts: [],
        // These do not matter for geojson exports
        includeDataFields: [],
        includeLevelColumn: false,
        includeLayerColumn: true,
        notificationId: uuid(),
        includeGroupColumn: false,
        cadOptions: null,
    };

    mappingApi.post(`maps/${mapId}/map_objects/exports`, request, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.export_error.title, { entity: translate(Content.map9.layer_geoJson) }),
            message: translate(Content.errors.custom_network_error.export_error.message, { entity: translate(Content.map9.layer_geoJson) }),
        },
    });

    return request;
};

export const exportLayerAsKml = (layers: DomainLayer[], mapId: string, unitOfMeasurement: UnitOfMeasurement) => {
    const request: MapObjectsExport = {
        mapId,
        layerIds: layers.map(({ id }) => id),
        export: undefined,
        exportFormat: ExportFormat.Kml,
        unitOfMeasurement,
        filters: [],
        sorts: [],
        includeDataFields: [],
        includeLevelColumn: false,
        includeLayerColumn: true,
        notificationId: uuid(),
        includeGroupColumn: layers.length > 1,
        cadOptions: null,
    };

    mappingApi.post(`maps/${mapId}/map_objects/exports`, request, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.export_error.title, { entity: translate(Content.map11.layer_kml) }),
            message: translate(Content.errors.custom_network_error.export_error.message, { entity: translate(Content.map11.layer_kml) }),
        },
    });

    return request;
};

export const exportLayerAsDwg = (layers: MapLayer[], mapId: string, level: number, cadOptions: MapObjectExportCadOptions) => {
    const request: MapObjectsExport = {
        mapId,
        layerIds: layers.map(({ id }) => id),
        export: undefined,
        exportFormat: ExportFormat.Dwg,
        filters: [{ $type: "IventisFilterNumber", fieldName: "level", operator: IventisFilterOperator.Eq, value: level } as FilterFormat],
        sorts: [],
        // These do not matter for geojson exports
        includeDataFields: [],
        includeLevelColumn: false,
        includeLayerColumn: true,
        notificationId: uuid(),
        includeGroupColumn: false,
        unitOfMeasurement: UnitOfMeasurement.Metric, // Not important but has to be set to something otherwise error
        cadOptions,
    };

    mappingApi.post(`maps/${mapId}/map_objects/exports`, request, {
        customErrorMessage: {
            title: translate(Content.errors.custom_network_error.export_error.title, { entity: translate(Content.map11.layer_dwg) }),
            message: translate(Content.errors.custom_network_error.export_error.message, { entity: translate(Content.map11.layer_dwg) }),
        },
    });

    return request;
};
